import { Action } from './Action.js';
import { Constants as C, methods as M } from '../observer/methods.js'
import i18next from "i18next";
/**
 * @class CallPOU
 * @extends Action
 * @classdesc Действие Вызвать программу
 * Вызвать ФБ в задаче объекта
 * */
export class CallPOU extends Action {

    async execute(context, execAsync) {
        const targetContext = context.currentTarget || context.target;
        const programId = this.ProgramId === "0"
            ? $sw.ItemSubscription._getParentParam(targetContext, 'objectid')
            : Number(this.ProgramId);
        const taskId = this.TaskId === -1
            ? $sw.ItemSubscription._getParentParam(targetContext, 'taskid')
            : this.TaskId;
        const outerPath = this.ProgramId === "0"
            ? $sw.ItemSubscription._getOuterPath(targetContext)
            : "";
        if (!this.IsScreenTask) {
            const pack = {
                recs: [{
                    itemId: programId,
                    outParams: this._calcResaultParam(this.Results),
                    params: this._calcParam(this.parameters, context),
                    path: outerPath + (this.ProgramPath ?? ""),
                    taskId: taskId
                }]
            };

            if (pack.recs[0].outParams && $sw.ItemSubscription.pendingCallPous.has(this.TaskId)) {
                const pending = $sw.ItemSubscription.pendingCallPous.get(this.TaskId);
                pending.recs.push(pack.recs[0]);
                pending.receivers.push(rec => this.processResult(rec, programId));
                if (!execAsync)
                    await pending.promise;
                return;
            }

            if (!$sw.ItemSubscription.pendingCallPous.has(this.TaskId))
                this.addNewPending();

            const options = {
                methodType: C.single,
                method: M.CallPOU,
                pack,
            };
            const proc = data => {
                if (data.recs?.length > 0)
                    this.processResult(data.recs[0], programId);
                this.processPending();
            }

            if (!execAsync) {
                await new Promise(resolve => {
                    $sw.ServerAdapter.sendRequest(options, data => resolve(proc(data)));
                });
            } else {
                $sw.ServerAdapter.sendRequest(options, proc);
            }

        } else {
            if ($TaskManager && this.ProgramPath) {
                $TaskManager.tasks.generatedTask.postMessageCallPOU(this.ProgramPath, this.parameters, this)
            }
        }
    }

    addNewPending() {
        let resolve;
        const promise = new Promise((res, rej) => {
            resolve = res;
        });
        $sw.ItemSubscription.pendingCallPous.set(this.TaskId, { recs: [], receivers: [], promise, resolve });
    }

    processPending() {
        if ($sw.ItemSubscription.pendingCallPous.has(this.TaskId)) {
            const newPending = $sw.ItemSubscription.pendingCallPous.get(this.TaskId);
            if (newPending?.recs.length > 0) {
                this.addNewPending();
                const proc = data => {
                    if (data.recs?.length > 0) {
                        for (let i = 0; i < data.recs.length; i++) {
                            newPending.receivers[i](data.recs[i]);
                        }
                    }
                    newPending.resolve();
                    this.processPending();
                }
                const options = {
                    methodType: C.single,
                    method: M.CallPOU,
                    pack: { recs: newPending?.recs },
                };
                $sw.ServerAdapter.sendRequest(options, proc);
            }
            else
                $sw.ItemSubscription.pendingCallPous.delete(this.TaskId);
        }
    }

    processResult(rec, programId)
    {
        if (rec.statusCode === 0x801F0000) {
            $ns.add({
                type: "error",
                time: new Date().toLocaleString(),
                title: i18next.t("call_pou_error"),
                text: String.format(i18next.t("call_pou_error_rights"), programId),
            });
            return;
        }

        if (rec.outParams) {
            const enoIndex = this.Results.findIndex((el) => {
                return el.name === 'EnO';
            })

            if (enoIndex > -1 && rec.outParams[enoIndex] === null) {
                $ns.add({
                    type: 'error',
                    time: new Date().toLocaleString(),
                    title: i18next.t("call_pou_error"),
                    text: String.format(i18next.t("call_pou_error_rights"), programId),
                    obj: this.parameters
                });
                if (rec.outParams[enoIndex] === null) return;
            }
            for (let i = 0; i < rec.outParams.length; i++) {
                const el = rec.outParams[i];
                if (this.prop_link[this.Results[i].name.toLowerCase()]) {
                    let val;
                    switch (typeof el) {
                        case 'object':
                            val = el && !el.dataType && !el.value
                                ? { dataType: this.Results[i].type,
                                    value: JSON.parse(JSON.stringify(el)) }
                                : '';
                            break;
                        default:
                            val = el;
                            break;
                    }
                    this.prop_link[this.Results[i].name.toLowerCase()](val, null, null, null, { forced: true });
                }
            }
        }
    }

    _calcResaultParam(param) {
        for (let i = 0; i < param.length; i++) {
            const el = param[i];
            if (el.hasOwnProperty('value')) {
                el.name = el.value;
                delete el.value;
            }
        }
        return param;
    }

    _calcParam(param, context) {
        let res = [];
        for (const key in param) {
            if (this.parameters_names?.includes(key))
            {
                res.push({ name: key, value: this.calcParam(param[key], context, this.event_parameters) })
            }
        }
        return res;
    }

    isConditionParam(param) {
        return this.conditions.reduce((acc, cond) => acc || cond.Value.type === param || cond.Operand.type === param, false);
    }
}